<template>
  <div id="courseware-container" />
</template>
<script>
import { watch, onBeforeUnmount, onMounted } from '@vue/composition-api'
import { PlayerSDK, PlatformType, IPlayerMessage } from 'axx-slide-sdk'
import { fullScreenSwitch } from './util'

let _playerSDK = null

export default {
  props: {
    uuid: String,
    data: Object
  },
  setup(props, { emit }) {
    let isFullScreen = false

    const handlePlayerMounted = () => {
      _playerSDK.addEventListener(IPlayerMessage.ON_PLAYER_CLICK_FULLSCREEN, () => {
        isFullScreen = !isFullScreen
        fullScreenSwitch(isFullScreen, document.getElementById('courseware-container'))
      })
      // 后续开发可能用到
      _playerSDK.addEventListener(IPlayerMessage.ON_PLAYER_GO_PAGE, data => {
        emit('playerMessage', {
          type: IPlayerMessage.ON_PLAYER_GO_PAGE,
          data
        })
      })
    }

    const show = (uuid, params) => {
      if (!uuid) return

      const { type, cwSign, cwPf, cwExpired, cwUser } = params
      let coursewareType = params.type
      if (uuid.includes('img-courseware.aixuexi.com')) coursewareType = 'ispring'
      const playerConfig = {
        coursewareId: [uuid],
        coursewareType,
        platform: PlatformType.AXX,
        params: {
          renderMode: 'ondemand',
          cwSign,
          cwPf,
          cwExpired,
          cwUser
        },
        onPlayerMounted: handlePlayerMounted
      }

      if (_playerSDK === null) {
        _playerSDK = new PlayerSDK('#courseware-container', playerConfig)
      } else {
        _playerSDK.reload(playerConfig.coursewareId, playerConfig.params, type === 'ispring')
      }
    }

    watch(() => props.uuid, uuid => {
      show(uuid, props.data)
    })

    onMounted(() => {
      show(props.uuid, props.data)
    })

    onBeforeUnmount(() => {
      if (_playerSDK) {
        _playerSDK.destroy()
        _playerSDK = null
      }
    })
  }
}
</script>
<style lang="less" scoped>
#courseware-container {
  height: 100%;

  :deep(iframe) {
    width: 100%;
    height: 100%;
  }
}
</style>
